export class SongMetadataKeeper {
  constructor(rawContent) {
    this.rawContent = rawContent;
    this.header = '';
    this.songs = this.splitSongs(rawContent);
  }

  splitSongs(content) {
    const lines = content.split('\n');
    const songs = [];
    let currentSong = '';
    let isHeader = true;

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      const isTitleLine = line.trim().match(/^\s*\[Title:\s*(.*)\]\s*$/i);

      if (isTitleLine) {
        if (isHeader) {
          // Koniec nagłówka, zaczynamy pierwszą piosenkę
          isHeader = false;
        } else if (currentSong.trim()) {
          // Jeśli to nie jest pierwsza piosenka, zapisz poprzednią i zacznij nową
          songs.push(currentSong.trim());
          currentSong = '';
        }
        // Dodaj linię tytułu do aktualnej piosenki
        currentSong += line + '\n';
      } else {
        if (isHeader) {
          // Jesteśmy przed pierwszym tytułem - to jest nagłówek
          this.header += line + '\n';
        } else {
          // Dodaj linię do aktualnej piosenki
          currentSong += line + '\n';
        }
      }
    }

    // Dodaj ostatnią piosenkę, jeśli istnieje
    if (currentSong.trim()) {
      songs.push(currentSong.trim());
    }

    return songs;
  }

  addOrUpdateTag(songIndex, tagKey, tagValue) {

    const songLines = this.songs[songIndex].split('\n');
    const tagLineIndex = songLines.findIndex(line => line.match(new RegExp(`^\\s*\\[(${tagKey}):\\s*(.*)\\]\\s*$`, 'i')));

    if (tagLineIndex !== -1) {
      songLines[tagLineIndex] = `[${tagKey}: ${tagValue}]`;
    } else {
      const titleLineIndex = songLines.findIndex(line => line.match(/^\s*\[Title:\s*(.*)\]\s*$/i));
      songLines.splice(titleLineIndex + 1, 0, `[${tagKey}: ${tagValue}]`);
    }

    this.songs[songIndex] = songLines.join('\n');
    return true;
  }

  removeSong(songIndex) {
    if (songIndex >= 0 && songIndex < this.songs.length) {
      // Remove the song at the specified index
      this.songs.splice(songIndex, 1);
      return true;
    }
    return false;
  }

  moveSong(fromIndex, toIndex) {
    if (fromIndex < 0 || fromIndex >= this.songs.length ||
      toIndex < 0 || toIndex >= this.songs.length) {
      console.error('Nieprawidłowy indeks piosenki:', fromIndex, toIndex);
      return false;
    }

    // Jeśli indeksy są takie same, nie ma potrzeby przesuwania
    if (fromIndex === toIndex) {
      return true;
    }

    // Pobierz piosenkę do przesunięcia
    const songToMove = this.songs[fromIndex];

    // Usuń piosenkę z aktualnej pozycji
    this.songs.splice(fromIndex, 1);

    // Wstaw piosenkę na nową pozycję
    this.songs.splice(toIndex, 0, songToMove);

    return true;
  }

  getUpdatedContent() {
    return this.header + this.songs.join('\n\n');
  }
}
